import { SetAppConfigsAction, SET_APP_CONFIGS, Config } from './types'

export const setAppConfigs = (configs: Config): SetAppConfigsAction => ({
  type: SET_APP_CONFIGS,
  payload: configs
})
